// extracted by mini-css-extract-plugin
export default {"table":"CanDataWrapper_table__EHeRv","wrapper":"CanDataWrapper_wrapper__FpRUx"};